<template>
  <div>
    <div class="ou-donation-form givingmainform">
      <div class="holder">
        <PaymentForm formId="ou-giving" class="form-horizontal forms-hor">
          <FormSection title="1. I would like to give:">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD','ILS', 'CAD']" style="max-width:180px"/>
            </FormRow>
            <div>
              <AmountSelectorList />
              <ErrorLabel field="amount" />
            </div>
            <br />
            <OuGivingPaymentOptions addMonthly />
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="2. Personal Information">
            <div id="personalInfo">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
            </FormRow>
            <DonorAddress />
            <FormRow inline>
            <FormCol field="phone" />
          </FormRow>
            <Consent privacy="https://www.ou.org/privacy-policy/"/>
          </div>
          </FormSection>
          <FormSection title="3. Payment Information" last>
            <FormRow>
              <Receipt />
            </FormRow>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                    </FormRow>
          </FormSection>

          <br />
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  type PropType,
  ref,
  watch,
  nextTick
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, submit, setValue, gateways } = usePaymentForm();

    // Default to US Receipt on load (defaultCurrency is USD)
    const stopWatcher = watch(gateways, (g) => {
      if (g?.USReceipt) {
        setValue('gateway', g.USReceipt as string);
        stopWatcher();
      }
    }, { immediate: true });

    return {
      form,
      submit,
      setValue
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

::v-deep .ou-donation-form {
  line-height: 1.4;
  hr {
    // margin-bottom: 30px;
    // padding-bottom: 30px;
    border-bottom: 2px dashed #ddd;
  }
  h2 {
    color: #3399f3;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 15px;
  }

  input[type="email"],
  input[type="number"],
  input[type="password"],
  input[type="tel"],
  input[type="text"],
  textarea,
  select {
    font-size: 14px;
  }
  input[type="tel"] {
    height: 42px;
  }
}
::v-deep .frequency {
  display: flex;
  justify-content: space-between;

  .styled-radio-container--ou-donation.styled-radio-contain {
    margin: 0px 0px 0px auto;
    justify-content: flex-end;

    .radio-part {
      margin-bottom: 0px;
    }
    input[type="radio"] {
      position: relative;
    }
  }
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right: 5px;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep #amount_other {
  height: 60px;
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="12"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "college student special";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}

// ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:not(:checked) + label[data-amount="100"] {
//   background: #eee7fd;
// }

::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:not(:checked) + label {
  background: #e5e8e9;
  color: #222;
}
::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:checked + label {
  background: #3399f3;
  color: white;
}
::v-deep .styled-radio--ou-donation.styled-radio .amount_other__wrapper {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
}
::v-deep .ou-donation-form .ou-donation-btn {
  background: #3399f3;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}
::v-deep .thank-you-container .ou-donation-btn {
  background: #3399f3;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}

.donate__note {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid rgb(214, 233, 198);
  border-radius: 4px;
  color: rgb(60, 118, 61);
  background-color: rgb(223, 240, 216);
}

.membership {
  font-size: 14px;
  margin: 15px 0;
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f;
  padding: 11px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  p {
    margin: 0;
  }
  a {
    color: #2403ee;
    font-weight: bold;
  }
}
</style>
